import axios from "../axios/AxiosInstance";

const preferenceKey = () => {
  const user = localStorage.getItem("userId") || localStorage.getItem("userEmail");
  return user ? `lastAgency:${user}` : null;
};

export function rememberAgency(id, name, city) {
  localStorage.setItem("agencyName", name);
  localStorage.setItem("agencyCity", city);
  const key = preferenceKey();
  if (key) localStorage.setItem(key, JSON.stringify({ id, name, city }));
}

export async function restoreAgency() {
  const key = preferenceKey();
  if (!key) return true;
  let agency;
  try {
    agency = JSON.parse(localStorage.getItem(key));
  } catch {
    localStorage.removeItem(key);
    return true;
  }
  if (!agency?.id || typeof agency.name !== "string" || typeof agency.city !== "string") return true;
  try {
    await axios.post("agency/switch", { agency: agency.id });
    rememberAgency(agency.id, agency.name, agency.city);
    return true;
  } catch (error) {
    // Keep the agency returned by login if restoring the preference fails.
    if (error.response?.status === 403 || error.response?.status === 404) localStorage.removeItem(key);
    return false;
  }
}
